import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contentType", "contentId"];
import ReducedLessonCard from './subcomponents/ReducedLessonCard';
import ReducedTrackCard from './subcomponents/ReducedTrackCard';
import { ReducedPlaylistCard } from '../../../features/savedItems';
import { ReducedShortCard } from '../../../features/cards';
import { HasGate } from '../../../features/accounts';
import { jsx as _jsx } from "react/jsx-runtime";
const ReducedContentCard = _ref => {
  let {
      contentType,
      contentId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    language
  } = props;
  if (contentType === 'track') {
    return /*#__PURE__*/_jsx(ReducedTrackCard, Object.assign({
      trackId: contentId
    }, props));
  } else if (contentType === 'lesson') {
    return /*#__PURE__*/_jsx(ReducedLessonCard, Object.assign({
      lessonId: contentId
    }, props));
  } else if (contentType === 'short' && language) return /*#__PURE__*/_jsx(HasGate, {
    gate: "Academy:ShortFormContent",
    children: /*#__PURE__*/_jsx(ReducedShortCard, Object.assign({
      language: language,
      shortId: contentId
    }, props))
  });
  return /*#__PURE__*/_jsx(ReducedPlaylistCard, Object.assign({
    playlistId: contentId
  }, props));
};
export default ReducedContentCard;